var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-cart"},[_c('div',{staticClass:"icon-cart__count"},[_vm._v("\n    "+_vm._s(_vm.count)+"\n  ")]),_vm._v(" "),_c('SvgCart',{staticClass:"icon-cart__shape"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }